<template>
  <div class="popup-full">
    <div class="popup-full__wrap">
      <BasePreloader v-if="pending"/>
      <button type="button"
              @click.prevent="close"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div class="popup-full__content">
          <div class="popup-full__media">
            <picture class="popup-full__img">
              <img src="../../assets/img/take-to-work.jpg"
                   :alt="$tResumeCard('Take to work')">
            </picture>
          </div>

          <h3 class="popup-full__title">{{ $tResumeCard('Take to work') }}</h3>
          <div class="popup-full__text text">
            <p>{{ $tResumeCard('Take to work text') }}</p>
          </div>

          <BaseAlert :value="error"
                     class="popup-full__error  _warning"/>

          <div class="popup-full__buttons">
            <button type="button"
                    @click.prevent="onAccept"
                    class="popup-full__btn  base-btn base-btn--green">
              <span>{{ $tResumeCard('Go to checkout') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'

  export default {
    name: 'TakeToWork',
    props: {
      resumeId: Number,
      vacancyId: Number,
      sharedResume: {
        type: Boolean,
        default: false,
      },
      callBack: Function
    },
    data() {
      return {
        pending: false,
        error: null
      }
    },
    computed: {
      sharedResumeHash() {
        if (!this.sharedResume) return undefined;
        return this.$route.params.sharedResumeHash;
      },
    },
    methods: {
      close() {
        this.$vModal.close('take-to-work')
      },
      onAccept() {
        this.error = null
        this.pending = true

        http.post('/api/new-interaction/create', {
          resume_id: this.resumeId,
          vacancy_id: this.vacancyId,
          hash: this.sharedResumeHash,
        }).then(({data}) => {
          this.close()
          // this.$router.push({
          //   name: 'account-interaction',
          //   params: {
          //     id: res.data.data.id
          //   }
          // })
          if(this.callBack) {
            this.callBack(data)
          }
        }).catch(error => {
          this.error = error.response && error.response.data && error.response.data.message
              || error.response.message
              || error.message
        }).finally(() => {
          this.pending = false;
        });
      },
    }
  }
</script>

<style>

</style>
